import { render, staticRenderFns } from "./CoozzyHeader.vue?vue&type=template&id=14139f20&scoped=true"
import script from "./CoozzyHeader.vue?vue&type=script&lang=js"
export * from "./CoozzyHeader.vue?vue&type=script&lang=js"
import style0 from "./CoozzyHeader.vue?vue&type=style&index=0&id=14139f20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14139f20",
  null
  
)

export default component.exports